/**************************************************
 * Nombre:       IngresoTexto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {InputAdornment, TextField} from "@mui/material";
import {Brightness1} from "@mui/icons-material";


const IngresoTexto = ({
                          props,
                          nombre,
                          dato,
                          lineas = 1,
                          Icono = Brightness1,
                          requerido = false,
                          size = 'small',
                          type = 'text',
                          editable = true,
                          ejemplo = ''
                      }) => {
    const {register, errors} = props

    return (
        <TextField
            color={'primary'}
            focused={lineas > 1}
            placeholder={ejemplo}
            slotProps={lineas <= 1 ? {
                    input: {
                        startAdornment: (

                            <InputAdornment position="start">
                                <Icono color={'primary'}/>
                            </InputAdornment>
                        ),
                        disableUnderline: true,
                        sx: {color: '#fff', backgroundColor: '#ffffff30'}
                    },
                    inputLabel: {
                        sx: {marginLeft: -1, color: '#fff'}
                    }
                } :

                {
                    input: {
                        disableUnderline: true
                    },
                    inputLabel: {
                        sx: {marginLeft: -1, color: '#fff'}
                    }
                }
            }
            // color={'info'}
            disabled={!editable}
            fullWidth
            size={size}
            label={nombre}
            multiline={lineas > 1} rows={lineas}
            type={type}
            {...register(dato, {required: requerido})}
            error={!!errors[dato]}
            helperText={errors[dato]?.message}

        />
    )

}
export default IngresoTexto